import { createSlice, CaseReducer, PayloadAction } from "@reduxjs/toolkit";
import { DialogComponents } from "@Interfaces";

type IDialogProps = {
    canceled?: boolean;
    maxWidth?: string;
    /** Fixed paper width: px, or a CSS length (still shrinks to fit small screens). */
    paperWidth?: number | string;
    showHeaderLogo?: boolean;
    // Optional header background image for dialogs that support it
    coverUrl?: string;
    fullScreen?: boolean;
    disableEscapeKeyDown?: boolean;
};

type IGlobalModalState = {
    open: boolean;
    componentId: DialogComponents | string;
    props?: IDialogProps;
};

const initialState: IGlobalModalState = {
    open: false,
    componentId: "",
    props: {},
};

// ***************************************
// Reducers
// ****************************************

const hideDialog: CaseReducer<IGlobalModalState> = (state) => {
    state.open = false;
    state.componentId = "";
};

const openDialog: CaseReducer<
    IGlobalModalState,
    PayloadAction<{ id: DialogComponents | string; props?: {} }>
> = (state, { payload: { id, props = {} } }) => {
    state.open = true;
    state.componentId = id;
    state.props = props;
};

const dialogSlice = createSlice({
    name: "dialog",
    initialState,
    reducers: {
        openDialog,
        hideDialog,
    },
});

export const { name, actions } = dialogSlice;
export default dialogSlice.reducer;
